import Vue from 'vue'
// import FastClick from 'fastclick'
import VueScroller from 'vue-scroller'
import VueLazyload from 'vue-lazyload'
import VueVideoPlayer from 'vue-video-player'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'


import router from '@/router'
import App from './App'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import store from './store/store'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(VueScroller)
Vue.use(AlertPlugin)
Vue.use(VueAwesomeSwiper)
Vue.use(VueLazyload)
Vue.use(VueVideoPlayer)

// 全局检查导航钩子meta字段，判断是否进入登录页面
router.beforeEach((to, from, next) => {
let user = JSON.parse(window.localStorage.getItem('user'))
let validDate = window.localStorage.getItem('validDate')
if (to.matched.some(record => record.meta.requireAuth)) {
// 当前路由需要判断登录状态
if (!user || !validDate) {
// 首次登录用户
window.localStorage.to = JSON.stringify(to)
login()
return false
}

// 有效期为3天 86400000ms
if (new Date().getTime() - new Date(validDate).getTime() > 3600000) {
// 用户信息已失效
window.localStorage.removeItem('user')
window.localStorage.removeItem('validDate')
window.localStorage.to = JSON.stringify(to)
login()
return false
}
next()
} else {
// 当前路由不需要判断登录状态
next()
}
})

// 微信授权
function login() {
let redUrl = encodeURI(window.location.origin + '/login')
let url = `https://wechatauth.aiyaopai.com/auth/clientside?appid=wx76b9a692b8709d44&redirect_uri=${redUrl}&response_type=code&scope=snsapi_userinfo&state=21`
window.location.href = url
}

// FastClick.attach(document.body)

Vue.config.productionTip = false

new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js